export enum Lightlevel {
    light,
    normal,
    dark
}